import { Box, Button, Divider, Flex, Image, Text, VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Header from "../../Components/Common/Header";
import { useNavigate } from "react-router-dom";
import { Modal, Select } from "antd";
import FAQModal from "../../Components/Modals/FAQModal";
import { BuyerAPI } from "../../Apis/buyerAPI";
import { EventInterface } from "../../Interface/CommonInterface";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import moment from "moment";
import { Images } from "../../Assets/images";
import { MdOutlineEventAvailable, MdArrowBack } from "react-icons/md"; // Claude: back button 27-03-2026
import Loader from "../../Components/Loader/Loader";
import { useToastWrapper } from "../../Wrapper/toastWrapper";


type Props = {};

const Rewards = (props: Props) => {
  const [isModal, setIsModal] = useState(false);
  const [rewards, setRewards] = useState<any[]>([]);
  const [redemptions, setRedemptions] = useState<any[]>([]);
  const [pointsInHand, setPointsInHand] = useState<number>(0);
  const [totalInProgressPoints, setTotalInProgressPoints] = useState<number>(0);
  const [RRIDInProgressPoints, setRRIDInProgressPoints] = useState<number>(0);
  const [RRIDRedeemedPoints, setRRIDRedeemedPoints] = useState<number>(0);
  const [RRIDStatus, setRRIDStatus]= useState<string>("");
  const [RRIDRedemptionNotes, setRRIDRedemptionNotes]= useState<string>("");
  const [redemptionsSummary, setRedemptionsSummary] = useState<any>({});
  const [totalRedeemedPoints, setTotalRedeemedPoints] = useState<number>(0);
  const [events, setEvents] = useState<EventInterface[]>([]);
  const [event, setEvent] = useState<EventInterface>();
  const [loading, setLoading] = useState(false);

  const handleOpenModal = () => setIsModal(true);
  const handleCloseModal = () => setIsModal(false);

  const navigate = useNavigate();
  const { error } = useToastWrapper();
  
  const getRewardsAndEvents = async () => {
    try {
      setLoading(true);
      const [res1, res2] = await Promise.all([
        BuyerAPI.getEvents(),
        BuyerAPI.getBuyerProfile(),
      ]);

      let eventId = null;

      if (res1?.success && Array.isArray(res1.data.data)) {
        const pastEvents = res1.data.data
          .filter((s: { startDate: string }) => moment(s.startDate).isBefore(moment()))
          .reverse();
  
        if (pastEvents.length > 0) {
          const latestEvent = pastEvents.reverse()[0];
          setEvents(pastEvents);
          setEvent(latestEvent);
          eventId = latestEvent._id; // Ensure eventId is available
        }
      }

      if (res2) {
        const buyerId = res2.data.data._id;
        const rewardsPromise = BuyerAPI.getRewardsByBuyerId({ buyerId });

        // Claude: fetch redemptions summary with or without eventId (platform-level) 18-02-2026
        const summaryParams: any = { buyerId };
        if (eventId) summaryParams.eventId = eventId;
        const redemptionsSummaryPromise = BuyerAPI.getRedemptionsSummary(summaryParams);

        const [data1, data2] = await Promise.all([rewardsPromise, redemptionsSummaryPromise]);

        setRewards(data1.data.data.rewards);
        setRedemptionsSummary(data2.data);

        //Vishy 2025-02-28 New code to fetch rrIdInProgressPoints to be displayed in the reward statement
        const fetchRedemptions = async (): Promise<void> => {
          try {
            const response = await BuyerAPI.getRedemptions({buyerId});

            const redemptions = response.data || [];

            // Sort by `createdAt` in descending order (newest first)
            redemptions.sort((a: { createdAt: string }, b: { createdAt: string }) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );

            // Pick the latest redemption's rrId
            const latestRedemption = redemptions.length > 0 ? redemptions[0] : null;
            const rrIdInProgressPoints = latestRedemption ? latestRedemption.rrIdInProgressPoints : 0;
            const rrIdRedeemedPoints = latestRedemption ? latestRedemption.rrIdRedeemedPoints : 0;

            setRRIDInProgressPoints(rrIdInProgressPoints);
            setRRIDRedeemedPoints(rrIdRedeemedPoints);
            setRRIDStatus(latestRedemption ? latestRedemption.redemptionStatus: null);
            setRRIDRedemptionNotes(latestRedemption ? latestRedemption.redemptionNotes: null);
          } catch (error) {
            console.error("Error fetching redemptions:", error);
          }
        };
        fetchRedemptions();
      }
    } catch (err: any) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {getRewardsAndEvents(); },[]);
  useEffect(() => {
    if (rewards.length > 0) {
      setPointsInHand(rewards[0]?.closingBalance || 0);
    }
    
    setTotalInProgressPoints(redemptionsSummary?.totalInProgressPoints || 0);
    setTotalRedeemedPoints(redemptionsSummary?.totalRedeemedPoints || 0);
  
  }, [rewards, redemptionsSummary]);

  const FAQButton = () => {
    return (
      <AiOutlineQuestionCircle
        style={{
          position: "absolute",
          right: "0px",
          top: "0px",
          height: "36px",
          width: "36px",
        }}
        // onClick={handleOpenModal}
        onClick={() => {
          window.open("https://prontocommerce.com/aftr/rewards/", "_blank");
        }}
      />
    );
  };
  const onClosePopUp = () => {
    navigate(`/buyer/myaccount`);
  };
  return (
    // Claude: Light mint bg for consistency with other buyer screens 17-02-2026
    <Box display={"flex"} flexDir={"column"} width={"100%"} minH={"100dvh"} bg={"linear-gradient(180deg, #EDFCF5 0%, #FFFFFF 100%)"}>
      <Modal
        footer={null}
        title={null}
        open={isModal}
        onCancel={handleCloseModal}
        closeIcon={null}
        onOk={handleCloseModal}
      >
        <FAQModal handleCloseModal={handleCloseModal} />
      </Modal>
      {/* Claude: Dark header with "Rewards" title matching other pages 16-02-2026 */}
      {/* Claude: AFTR logo on right side of dark header 23-02-2026 */}
      <Flex
        w={"100%"}
        px={"30px"}
        py={5}
        bg={"#0E122F"}
        color={"white"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        {/* Claude: back button 27-03-2026 */}
        <Flex alignItems="center" gap={3} cursor="pointer" onClick={() => navigate(-1)}>
          <MdArrowBack size={20} color="white" />
          <Text fontSize={"xl"} fontWeight={700}>Rewards</Text>
        </Flex>
        {/* Claude: role label below logo in header 25-02-2026 */}
        <VStack spacing={0} alignItems="center" justifyContent="center">
          <Image src={Images.AftrLogo} h="32px" objectFit="contain" />
          <Text fontSize="11px" fontWeight={300} color="whiteAlpha.600" letterSpacing="wide">
            buyer (beta)
          </Text>

        </VStack>
      </Flex>
      <Box p={6} maxW="800px">
        <VStack spacing={6} align="flex-start" flexDirection={"column"}>
          {/* Claude: removed Events dropdown — rewards are platform-level, no event filter needed 20-02-2026 */}
        </VStack>
      </Box>

      {loading ?
        <Loader />
       : 
      <>
      {rewards.length > 0 ? (
        <Flex
          alignItems={"center"}
          w={"100%"}
          bg={"#0013BC"}
          bgImage={Images.RewardsBanner}
          backgroundSize="cover"
          direction={"column"}
          // backgroundRepeat="no-repeat"
          // backgroundPosition="center"
          py={"40px"}
          px={"30px"}
        >
          <VStack
            w={"100%"}
            textAlign={"left"}
            justifyContent={"space-between"}
            display={"flex"}
            flexDirection={"row"}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              width={"30%"}
              alignItems={"center"}
            >
              <Text fontWeight={500} color={"white"} fontSize={"48px"}>
                {pointsInHand}
              </Text>
              <Text
                fontSize={"18px"}
                color={"white"}
                textAlign={"center"}
                fontWeight={"semibold"}
              >
                Points in hand
              </Text>
              <Button
                mt={1}
                h={"36px"}
                textAlign={"center"}
                bg={"secondary.main"}
                color={"secondary.light"}
                _hover={{
                  backgroundColor: "secondary.lightHover",
                }}
                onClick={() => {
                  if(pointsInHand <= 0)
                    return error("You don't have enough points to redeem");
                  else
                  navigate("/buyer/redemption-verification"); //Vishy 2025-02-23 renamed from rewards-redeem
                }}
              >
                Redeem
              </Button>
            </Box>
            <Box width={"50%"} fontWeight={"semibold"}>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                width={"100%"}
                fontSize={"18px"}
                color={"secondary.main"}
              >
                <Text fontSize={"26px"}>{totalInProgressPoints}</Text>
                <Text>Redemption in-progress</Text>
              </Box>
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                width={"100%"}
                fontSize={"18px"}
                color={"#00FF00"}
              >
                <Text fontSize={"26px"}>{totalRedeemedPoints}</Text>
                <Text>Redeemed</Text>
              </Box>
            </Box>
          </VStack>
        </Flex>
      ) : (
        // Claude: Removed blue bg and icon, normalized font for empty rewards message 17-02-2026
        <Flex
          w={"100%"}
          py={"20px"}
          px={"30px"}
        >
          <Text fontSize={"14px"} color={"text.black"}>
            Watch this space for updates on reward points. Contact support@aftr.network for more details.
          </Text>
        </Flex>
      )}

      {/* Claude: Hide Statement section when no rewards 17-02-2026 */}
      {rewards.length > 0 && <Box mt={4}>
        <Text
          fontSize={"15px"}
          fontWeight={"semibold"}
          color={"text.black"}
          textAlign={"center"}
        >
          Statement
        </Text>
        <VStack>
          {/* {[0, 0, 0].map(() => ( */}
          {rewards?.map((rewardStatement) => (
            <Box
              w={"100%"}
              bg={"#C9DCEF"}
              p={3}
              rounded={"18px"}
              mt={3}
              px={5}
              py={4}
              display={"flex"}
              gap={4}
              justifyContent={"space-between"}
              alignItems={"start"}
              shadow={"md"}
              minH={"95px"}
              fontSize={"15px"}
            >
              <Box>
                <Text mb={3}>
                  <span style={{ fontWeight: "bold" }}>{"Date: "}</span>
                  {moment(rewardStatement?.updatedAt).format(
                    "DD MMMM YYYY, HH:mm a"
                  )}
                </Text>

                {rewardStatement?.txnType == "Add" && (
                  <>
                    <Text mt={1}>
                      <span style={{ fontWeight: "bold" }}>{"Points Added: "}</span>
                    {rewardStatement?.points}
                  </Text>
                  {rewardStatement?.rewardNotes && (
                    <Text mt={1}>
                      <span style={{ fontWeight: "bold" }}>{"Reward Notes: "}</span>
                      {rewardStatement?.rewardNotes}
                    </Text>
                  )}
                  </>
                )}
                
              {rewardStatement?.txnType == "Redeem" && (
                <>                  
                  <Text mt={1}>
                    <span style={{ fontWeight: "bold" }}>{"Redemption Id: "}</span>
                    {rewardStatement?.redemptionRequestId}
                  </Text>
                  <Text mt={1}>
                    <span style={{ fontWeight: "bold" }}>{"Redemption Points: "}</span>
                    {Math.max(RRIDInProgressPoints || 0, RRIDRedeemedPoints || 0)}
                  </Text>
                  <Text mt={1}>
                    <span style={{ fontWeight: "bold" }}>{"Redemption Status: "}</span>
                    { RRIDStatus }
                  </Text>
                  <Text mt={1}>
                    <span style={{ fontWeight: "bold" }}>{"Redemption Notes: "}</span>
                    { RRIDRedemptionNotes }
                  </Text>


                </>
                )}
              </Box>
            </Box>
          ))}
         
        
        </VStack>
      </Box>}
      </>}
    </Box>
  );
};

export default Rewards;
